export { default } from './ChatContentView.component';
export type { ChatContentViewProps } from './ChatContentView.component';
